import React, { FunctionComponent } from "react"
import Grid from "../../components/Grid/Grid"
import LinkItem from "../../components/Grid/LinkItem"
import Loader from "../../components/Loader/Loader"
import Seo from "../../components/Seo/Seo"
import { iNews, iNewsQuery } from "../../definitions/News"
import { useData } from "../../hooks/useData"
import NewsFilters from "./Filters"
import NewsItem from "./Item"

const News: FunctionComponent = () => {
  const { loading, data, total, setQuery, query } = useData<iNewsQuery, iNews>({
    link: "/v2/news",
    defaultQuery: {},
    shouldPushQuery: true,
  })

  return (
    <>
      <Seo title="News | Dashboard | VR-All-Art" />
      <div className="content">
        <div className="content-header">
          <h1>News ({total})</h1>
          <NewsFilters query={query} setQuery={setQuery} />
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : data.length ? (
        <div className="grid-wrap">
          <Grid>
            {data.map((d, i) => (
              <LinkItem key={i} url={"/news/" + d.url}>
                <NewsItem {...d} />
              </LinkItem>
            ))}
          </Grid>
        </div>
      ) : (
        <div className="no-data">No matching results.</div>
      )}
    </>
  )
}

export default News
